import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		pageTitle: '',
		eventInfo: {
			EventName: "",
			EventID: "",
			event_url:""
		}
	},
	mutations: {
		setPageTitle(state, payload) {
			state.pageTitle = payload;
		},
		setEventInfo(state, payload) {
			//console.log("tdtdtd",payload);
			state.eventInfo.EventName = payload.event_name;
			state.eventInfo.EventID = payload.event_id;
			state.eventInfo.EventURL = payload.event_url;

		}
	},
	actions: {},
	modules: {}
});
